import { useMemo, useState } from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import Sidebar from './components/Sidebar.jsx';
import MapView from './components/MapView.jsx';
import useTranslate from './hooks/useTranslate.jsx';

const API_KEY = 'AIzaSyCHM2wQJFK53AAJKcxALpfHhkKQRCkACQ0';

const STORES = (window.storeLocatorData || []).map((s, i) => ({
  ...s,
  id: i + 1,
  lat: parseFloat(s.latitude),
  lng: parseFloat(s.longitude),
}));

const CATEGORIES = [...new Set(STORES.flatMap((s) => s.shop_types))];

function inBounds(store, b) {
  if (store.lat < b.south || store.lat > b.north) return false;
  // viewport a cavallo dell'antimeridiano: west > east
  return b.west <= b.east ? store.lng >= b.west && store.lng <= b.east : store.lng >= b.west || store.lng <= b.east;
}

export default function App() {
  const { t } = useTranslate();
  const [query, setQuery] = useState('');
  const [activeCategories, setActiveCategories] = useState(() => [...CATEGORIES]);
  const [selectedId, setSelectedId] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const [searchLocation, setSearchLocation] = useState(null);
  // bounds correnti della mappa, aggiornati a ogni idle
  const [bounds, setBounds] = useState(null);
  // il filtro per viewport si attiva solo dopo aver scelto un indirizzo
  const [viewportFilter, setViewportFilter] = useState(false);

  const locateMe = () => {
    if (!navigator.geolocation) {
      alert(t('geolocation.notSupported'));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setUserLocation({
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          ts: Date.now(),
        });
      },
      (err) => {
        alert(t('geolocation.error', { message: err.message }));
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  // const filteredStores = useMemo(() => {
  //   const q = query.trim().toLowerCase();
  //   return STORES.filter((s) => {
  //     if (!s.shop_types?.some((t) => activeCategories.includes(t))) return false;
  //     if (!q) return true;
  //     return s.store_name.toLowerCase().includes(q) || s.address.some((line) => line.toLowerCase().includes(q));
  //   });
  // }, [query, activeCategories]);

  const filteredStores = useMemo(() => {
    return STORES.filter((s) => {
      // if (!activeCategories.includes(s.category)) return false;
      if (!s.shop_types?.some((t) => activeCategories.includes(t))) return false;
      if (viewportFilter && bounds && !inBounds(s, bounds)) return false;
      return true;
    });
  }, [activeCategories, viewportFilter, bounds]);

  const handleQueryChange = (text) => {
    setQuery(text);
    // campo svuotato: si torna a vedere tutti i negozi
    if (text.trim() === '') setViewportFilter(false);
  };

  const handlePlaceSelect = (place) => {
    setSelectedId(null);
    setSearchLocation(place);
    setViewportFilter(true);
  };

  const toggleCategory = (id) => {
    setActiveCategories((prev) => (prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id]));
  };

  const selectedStore = filteredStores.find((s) => s.id === selectedId) || null;

  if (!API_KEY) {
    return (
      <div className="missing-key">
        <h2>{t('error.apiKeyMissing')}</h2>
        <p>{t('error.apiKeyMissingHint')}</p>
      </div>
    );
  }

  return (
    <APIProvider apiKey={API_KEY}>
      <div className="app">
        <Sidebar
          stores={filteredStores}
          totalCount={filteredStores.length}
          query={query}
          onQueryChange={handleQueryChange}
          categories={CATEGORIES}
          activeCategories={activeCategories}
          onToggleCategory={toggleCategory}
          selectedId={selectedId}
          onSelect={setSelectedId}
          onLocateMe={locateMe}
          onPlaceSelect={handlePlaceSelect}
          t={t}
        />
        <MapView
          stores={filteredStores}
          selectedStore={selectedStore}
          onSelect={setSelectedId}
          categories={CATEGORIES}
          userLocation={userLocation}
          searchLocation={searchLocation}
          onBoundsChange={setBounds}
          t={t}
        />
      </div>
    </APIProvider>
  );
}
